var map = {
	"./12.png": 44857,
	"./14.png": 23983,
	"./4.jpg": 36346,
	"./9.jpg": 35699,
	"./blog-2.jpg": 79225,
	"./blog-3.jpg": 81852,
	"./blog-5.jpg": 66634,
	"./blog-6.jpg": 17621,
	"./blog-single.jpg": 39703,
	"./blog.jpg": 94384,
	"./comment.jpg": 53181,
	"./img.png": 79579
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34346;